/* Centauri C20 - sticky scroll reveal. Progressive enhancement only:
   the base image is visible without JS; ScrollTrigger or the native fallback
   pins the section and triggers the reveal; the video overlay then plays on a
   timed animation instead of scrubbing against scroll progress. */
(function () {
  'use strict';

  var VERSION = '2026-07-14-bidirectional-autoplay-loop';
  var ROOT_SELECTOR = '[data-centauri-c20]';
  var COMPONENT_SCRIPT = 'centauri-c20-leaf-spring-top.js';
  var VIDEO_PRIME_MARGIN_PX = 1000;
  var VIDEO_READY_POLL_MS = 120;
  var REFERENCE_START_TOP_RATIO = 0.6;
  var REFERENCE_END_BOTTOM_OFFSET_PX = 100;
  var BASE_ENTRY_DURATION_RATIO = 0.4;
  var BASE_ENTRY_TRANSLATE_PX = 100;
  var BASE_ENTRY_SCALE_DELTA = 0.1;
  var COVER_REVEAL_DURATION_MS = 500;
  var COVER_OPACITY_DURATION_MS = 300;
  var COVER_TRANSLATE_PERCENT = 100;
  var BASE_REVEAL_SCALE_DELTA = 0.1;

  if (window.CentauriC20ScrollReveal && window.CentauriC20ScrollReveal.version === VERSION) {
    window.CentauriC20ScrollReveal.init();
    return;
  }

  var vendorStore = window.CentauriVendorPromises = window.CentauriVendorPromises || { scripts: {} };
  vendorStore.scripts = vendorStore.scripts || {};

  function desktopMode() {
    return !window.matchMedia || window.matchMedia('(min-width: 1024px)').matches;
  }

  function videoPrimeAllowed() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!connection) return true;
    if (connection.saveData) return false;
    var effectiveType = String(connection.effectiveType || '').toLowerCase();
    return effectiveType !== 'slow-2g' && effectiveType !== '2g';
  }

  function matches(node, selector) {
    if (!node || node.nodeType !== 1) return false;
    var fn = node.matches || node.msMatchesSelector || node.webkitMatchesSelector;
    return fn ? fn.call(node, selector) : false;
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function toBool(value, fallback) {
    if (value === undefined || value === null || value === '') return fallback;
    if (value === false || value === 'false' || value === '0' || value === 'no') return false;
    return true;
  }

  function clamp(value, min, max) {
    value = Number(value);
    if (!Number.isFinite(value)) return min;
    if (value < min) return min;
    if (value > max) return max;
    return value;
  }

  function findRootNodes(scope) {
    var target = scope && scope.querySelectorAll ? scope : document;
    var roots = [];
    if (matches(scope, ROOT_SELECTOR)) roots.push(scope);
    return roots.concat(toArray(target.querySelectorAll(ROOT_SELECTOR)));
  }

  function normalizeUrl(url) {
    var anchor = document.createElement('a');
    anchor.href = resolveAssetUrl(url);
    return anchor.href;
  }

  function resolveAssetUrl(url) {
    if (!url) return '';
    if (/^(https?:)?\/\//.test(url) || url.charAt(0) === '/') return url;
    if (url.indexOf('/') !== -1) return url;

    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
      var src = scripts[i].src || '';
      if (src.indexOf('/assets/' + COMPONENT_SCRIPT) !== -1) {
        return src.split('?')[0].replace(COMPONENT_SCRIPT, url);
      }
    }

    return url;
  }

  function loadScriptOnce(url, globalReady) {
    if (globalReady && globalReady()) return Promise.resolve();
    if (!url) return Promise.resolve();

    var normalized = normalizeUrl(url);
    if (vendorStore.scripts[normalized]) return vendorStore.scripts[normalized];

    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
      if (scripts[i].src === normalized) {
        vendorStore.scripts[normalized] = new Promise(function (resolve, reject) {
          var existing = scripts[i];
          if (globalReady && globalReady()) {
            resolve();
            return;
          }
          if (existing.readyState === 'complete' || existing.getAttribute('data-centauri-vendor-ready') === 'true') {
            resolve();
            return;
          }
          existing.addEventListener('load', function () {
            existing.setAttribute('data-centauri-vendor-ready', 'true');
            resolve();
          }, { once: true });
          existing.addEventListener('error', function () {
            reject(new Error('Unable to load C20 script: ' + normalized));
          }, { once: true });
        });
        return vendorStore.scripts[normalized];
      }
    }

    vendorStore.scripts[normalized] = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = normalized;
      script.async = false;
      script.setAttribute('data-centauri-c20-vendor', 'true');
      script.onload = function () {
        script.setAttribute('data-centauri-vendor-ready', 'true');
        resolve();
      };
      script.onerror = function () {
        reject(new Error('Unable to load C20 script: ' + normalized));
      };
      document.head.appendChild(script);
    });

    return vendorStore.scripts[normalized];
  }

  function loadVendors(root) {
    return loadScriptOnce(root.getAttribute('data-gsap-js'), function () { return !!window.gsap; })
      .then(function () {
        return loadScriptOnce(root.getAttribute('data-scrolltrigger-js'), function () { return !!window.ScrollTrigger; });
      });
  }

  function loadVendorDriveWhenNear(state) {
    if (!state || state.destroyed || state.vendorRequested || state.vendorObserver) return;

    function request() {
      if (!state || state.destroyed || state.vendorRequested) return;
      state.vendorRequested = true;
      if (state.vendorObserver && state.vendorObserver.disconnect) state.vendorObserver.disconnect();
      state.vendorObserver = null;
      loadVendors(state.root)
        .then(function () {
          configureScrollDrive(state);
        })
        .catch(function () {
          if (!state.destroyed && scrollDriveEligible(state)) setupNativeFallback(state);
        });
    }

    if (!('IntersectionObserver' in window)) {
      request();
      return;
    }

    state.vendorObserver = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          request();
          break;
        }
      }
    }, { rootMargin: '800px 0px' });
    state.vendorObserver.observe(state.root);
  }

  function resolveLengthPx(owner, value) {
    if (!owner || !value || value === '0' || value === '0px') return 0;
    var probe = document.createElement('div');
    probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;width:0;height:' + value + ';';
    owner.appendChild(probe);
    var px = probe.getBoundingClientRect().height;
    owner.removeChild(probe);
    return Number.isFinite(px) ? px : 0;
  }

  function stickyOffsetPx(state) {
    if (!state.root || !window.getComputedStyle) return 0;
    var value = window.getComputedStyle(state.root).getPropertyValue('--centauri-c20-sticky-offset').trim();
    if (state.stickyOffsetValue === value && Number.isFinite(state.stickyOffsetPx)) return state.stickyOffsetPx;
    var px = /px$/.test(value) ? parseFloat(value) : resolveLengthPx(state.root, value);
    state.stickyOffsetValue = value;
    state.stickyOffsetPx = Number.isFinite(px) ? px : 0;
    return state.stickyOffsetPx;
  }

  function switchThreshold(root) {
    var value = parseFloat(root.getAttribute('data-switch-threshold'));
    if (!Number.isFinite(value)) return 0.05;
    if (value > 1) value = value / 100;
    return clamp(value, 0.001, 0.2);
  }

  function visualProgress(scrollProgress) {
    return clamp(scrollProgress, 0, 1);
  }

  function referenceGyroProgress(state) {
    if (!state || !state.root || !desktopMode()) return 1;

    var rect = state.root.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 1;
    var startTop = vh * REFERENCE_START_TOP_RATIO;
    var endTop = vh - rect.height + REFERENCE_END_BOTTOM_OFFSET_PX;
    return clamp((startTop - rect.top) / Math.max(1, startTop - endTop), 0, 1);
  }

  function baseEntryProgress(state) {
    return clamp(referenceGyroProgress(state) / BASE_ENTRY_DURATION_RATIO, 0, 1);
  }

  function setBaseEntryProgress(state, progress) {
    if (!state || !state.root || !state.base) return;

    var value = clamp(progress, 0, 1);
    var fixed = value.toFixed(4);
    if (state.baseEntryProgress === fixed) return;
    state.baseEntryProgress = fixed;
    var inverse = 1 - value;
    state.root.style.setProperty('--c20-base-entry-opacity', fixed);
    state.root.style.setProperty('--c20-base-entry-y', (inverse * BASE_ENTRY_TRANSLATE_PX).toFixed(2) + 'px');
    state.root.style.setProperty('--c20-base-entry-scale', (1 + inverse * BASE_ENTRY_SCALE_DELTA).toFixed(4));
    state.root.setAttribute('data-c20-base-entry-progress', fixed);
  }

  function updateReferenceGyroMotion(state) {
    if (!state || state.destroyed) return;

    if (!scrollDriveEligible(state)) {
      setBaseEntryProgress(state, 1);
      return;
    }

    var referenceProgress = referenceGyroProgress(state);
    state.root.setAttribute('data-c20-reference-progress', referenceProgress.toFixed(4));
    setBaseEntryProgress(state, clamp(referenceProgress / BASE_ENTRY_DURATION_RATIO, 0, 1));
  }

  function videoDisplayed(video) {
    if (!video || !window.getComputedStyle) return true;
    var style = window.getComputedStyle(video);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function currentRevealVideo(state) {
    if (!state || !state.videos) return null;
    for (var i = 0; i < state.videos.length; i++) {
      if (videoDisplayed(state.videos[i])) return state.videos[i];
    }
    return state.videos[0] || null;
  }

  function updateVideoDiagnostics(state) {
    if (!state || !state.root) return;
    var video = currentRevealVideo(state);
    var ready = !!(video && video.readyState >= 2 && video.videoWidth > 0);
    state.root.setAttribute('data-c20-video-ready', ready ? 'true' : 'false');
    state.root.setAttribute('data-c20-video-width', video ? String(video.videoWidth || 0) : '0');
    state.root.setAttribute('data-c20-video-ready-state', video ? String(video.readyState || 0) : '0');
  }

  function revealVideoReady(video) {
    return !video || (video.readyState >= 2 && video.videoWidth > 0);
  }

  function rootWithinViewportMargin(root, margin) {
    if (!root || !root.getBoundingClientRect) return false;
    var rect = root.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 1;
    return rect.top <= vh + margin && rect.bottom >= -margin;
  }

  function hydrateDeferredVideo(video) {
    if (!video || !video.querySelectorAll) return false;
    var sources = video.querySelectorAll('source[data-src]');
    var hydrated = false;

    for (var i = 0; i < sources.length; i++) {
      var source = sources[i];
      if (!source.getAttribute('src') && source.getAttribute('data-src')) {
        source.setAttribute('src', source.getAttribute('data-src'));
        hydrated = true;
      }
    }

    if (hydrated) {
      try {
        if (video.load) video.load();
      } catch (e) {}
    }

    return hydrated;
  }

  function prepareVideoPlaybackAttrs(video, options) {
    if (!video) return;
    var autoplay = !!(options && options.autoplay);
    var preload = !options || options.preload !== false;
    var loop = !options || options.loop !== false;

    try {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = loop;
      video.playsInline = true;
      video.setAttribute('muted', '');
      if (loop) video.setAttribute('loop', '');
      else video.removeAttribute('loop');
      video.setAttribute('playsinline', '');
      if (autoplay) {
        video.autoplay = true;
        video.setAttribute('autoplay', '');
      }
      if (preload) {
        hydrateDeferredVideo(video);
        video.setAttribute('preload', 'auto');
        video.preload = 'auto';
        if (video.readyState < 2 && video.load) video.load();
      } else if (autoplay) {
        hydrateDeferredVideo(video);
      }
    } catch (e) {}
  }

  function prepareRevealVideos(state) {
    if (!state || state.destroyed || state.videosPrepared || !scrollDriveEligible(state)) return;
    state.videosPrepared = true;
    for (var i = 0; i < state.videos.length; i++) {
      var video = state.videos[i];
      if (!videoDisplayed(video)) continue;
      prepareVideoPlaybackAttrs(video, { autoplay: true });
    }
    updateVideoDiagnostics(state);
  }

  function primeRevealVideos(state) {
    if (!state || state.destroyed || state.videosPrimed || !scrollDriveEligible(state)) return;
    prepareRevealVideos(state);
    state.videosPrimed = true;

    for (var i = 0; i < state.videos.length; i++) {
      var video = state.videos[i];
      if (!videoDisplayed(video)) continue;
      try {
        prepareVideoPlaybackAttrs(video, { autoplay: true });

        var play = video.play();
        if (play && play.then) {
          (function (primedVideo, playPromise) {
            playPromise.then(function () {
              updateVideoDiagnostics(state);
              if (!state.destroyed && !state.revealActive) {
                try { primedVideo.pause(); } catch (e) {}
              }
            }).catch(function () {});
          })(video, play);
        } else if (!state.revealActive) {
          video.pause();
        }
      } catch (e) {}
    }
    updateVideoDiagnostics(state);
  }

  function cancelVideoReadyWait(state) {
    if (!state) return;
    if (state.videoReadyTimer) window.clearTimeout(state.videoReadyTimer);
    state.videoReadyTimer = 0;
    if (state.videoReadyCleanup) {
      try { state.videoReadyCleanup(); } catch (e) {}
      state.videoReadyCleanup = null;
    }
  }

  function waitForRevealVideo(state, callback) {
    if (!state || state.destroyed) return;

    cancelVideoReadyWait(state);
    var video = currentRevealVideo(state);
    if (revealVideoReady(video)) {
      state.root.setAttribute('data-c20-video-waiting', 'false');
      updateVideoDiagnostics(state);
      callback();
      return;
    }

    state.root.setAttribute('data-c20-video-waiting', 'true');
    var done = false;
    var events = ['loadeddata', 'canplay', 'canplaythrough'];

    function finish() {
      if (done || !state || state.destroyed || !state.autoRevealStarted) return;
      done = true;
      cancelVideoReadyWait(state);
      state.root.setAttribute('data-c20-video-waiting', 'false');
      updateVideoDiagnostics(state);
      callback();
    }

    function fail() {
      if (done || !state || state.destroyed || !state.autoRevealStarted) return;
      done = true;
      cancelVideoReadyWait(state);
      state.root.setAttribute('data-c20-video-waiting', 'error');
      updateVideoDiagnostics(state);
    }

    function maybeReady() {
      if (revealVideoReady(video)) finish();
    }

    for (var i = 0; i < events.length; i++) video.addEventListener(events[i], maybeReady);
    video.addEventListener('error', fail);
    state.videoReadyCleanup = function () {
      for (var i = 0; i < events.length; i++) video.removeEventListener(events[i], maybeReady);
      video.removeEventListener('error', fail);
    };

    function pollReady() {
      if (done || !state || state.destroyed || !state.autoRevealStarted) return;
      if (video && video.error) {
        fail();
        return;
      }
      if (revealVideoReady(video)) {
        finish();
        return;
      }
      state.videoReadyTimer = window.setTimeout(pollReady, VIDEO_READY_POLL_MS);
    }

    state.videoReadyTimer = window.setTimeout(pollReady, VIDEO_READY_POLL_MS);
  }

  function disconnectVideoPrimeObserver(state) {
    if (state.videoPrimeObserver && state.videoPrimeObserver.disconnect) state.videoPrimeObserver.disconnect();
    state.videoPrimeObserver = null;
  }

  function primeVideosWhenNear(state) {
    if (!state || state.destroyed || state.videosPrimed || !scrollDriveEligible(state)) return;
    if (!desktopMode() || !videoPrimeAllowed()) return;

    if (rootWithinViewportMargin(state.root, VIDEO_PRIME_MARGIN_PX)) {
      disconnectVideoPrimeObserver(state);
      primeRevealVideos(state);
      return;
    }

    if (state.videoPrimeObserver || !('IntersectionObserver' in window)) {
      if (!('IntersectionObserver' in window)) primeRevealVideos(state);
      return;
    }

    state.videoPrimeObserver = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          disconnectVideoPrimeObserver(state);
          primeRevealVideos(state);
          break;
        }
      }
    }, { rootMargin: VIDEO_PRIME_MARGIN_PX + 'px 0px' });
    state.videoPrimeObserver.observe(state.root);
  }

  function updateMediaPlayback(state) {
    if (mobileLoopEligible(state)) {
      updateMobileLoopPlayback(state);
      return;
    }

    var allow = state.revealActive && state.inViewport !== false && !document.hidden;
    if (allow) primeRevealVideos(state);
    for (var i = 0; i < state.videos.length; i++) {
      var video = state.videos[i];
      try {
        prepareVideoPlaybackAttrs(video, { preload: false, autoplay: true });
        if (allow && videoDisplayed(video)) {
          var play = video.play();
          if (play && play.catch) play.catch(function () {});
        } else {
          video.pause();
        }
      } catch (e) {}
    }
    updateVideoDiagnostics(state);
  }

  function restartRevealVideos(state) {
    if (!state || !state.videos) return;
    for (var i = 0; i < state.videos.length; i++) {
      var video = state.videos[i];
      if (!videoDisplayed(video)) continue;
      try {
        if (Number.isFinite(video.duration) && video.duration > 0) video.currentTime = 0;
      } catch (e) {}
    }
  }

  function setRevealProgress(state, progress) {
    if (!state || !state.root) return;

    var revealValue = clamp(progress, 0, 1);
    var revealFixed = revealValue.toFixed(4);
    var opacityValue = clamp(revealValue * COVER_REVEAL_DURATION_MS / COVER_OPACITY_DURATION_MS, 0, 1);
    var opacityFixed = opacityValue.toFixed(4);
    var offset = ((1 - revealValue) * COVER_TRANSLATE_PERCENT).toFixed(2) + '%';
    var baseRevealScale = (1 - revealValue * BASE_REVEAL_SCALE_DELTA).toFixed(4);
    var revealActive = state.autoRevealStarted || revealValue > state.threshold;

    state.root.style.setProperty('--c20-media-progress', revealFixed);
    state.root.style.setProperty('--c20-reveal-progress', revealFixed);
    state.root.style.setProperty('--c20-media-offset', offset);
    state.root.style.setProperty('--c20-reveal-opacity', opacityFixed);
    state.root.style.setProperty('--c20-base-reveal-scale', baseRevealScale);
    state.root.setAttribute('data-c20-media-progress', revealFixed);
    state.root.setAttribute('data-c20-reveal-progress', revealFixed);
    state.root.setAttribute('data-c20-reveal-opacity-progress', opacityFixed);
    state.root.setAttribute('data-c20-media-offset', offset);
    state.root.setAttribute('data-c20-base-reveal-scale', baseRevealScale);
    state.root.classList.toggle('is-c20-active-reveal', revealActive);
    state.root.classList.toggle('is-c20-active-base', !revealActive);
    state.root.setAttribute('data-c20-active-index', revealActive ? '1' : '0');

    if (state.reveal) state.reveal.setAttribute('aria-hidden', 'true');
    if (state.revealActive !== revealActive) {
      state.revealActive = revealActive;
      updateMediaPlayback(state);
    }
  }

  function cancelAutoReveal(state) {
    if (state && state.autoRevealFrame) window.cancelAnimationFrame(state.autoRevealFrame);
    if (state) state.autoRevealFrame = 0;
  }

  function resetAutoReveal(state) {
    if (!state || state.destroyed) return;
    cancelAutoReveal(state);
    cancelVideoReadyWait(state);
    state.autoRevealStarted = false;
    state.hasAutoRevealed = false;
    state.revealTarget = 0;
    state.revealDirection = 'idle';
    state.revealProgress = 0;
    state.root.setAttribute('data-c20-video-waiting', 'false');
    state.root.setAttribute('data-c20-reveal-direction', 'idle');
    state.root.setAttribute('data-c20-auto-revealed', 'false');
    setRevealProgress(state, 0);
  }

  function animateRevealTo(state, target) {
    if (!state || state.destroyed) return;

    cancelAutoReveal(state);
    target = clamp(target, 0, 1);
    var startProgress = clamp(state.revealProgress || 0, 0, 1);
    state.revealDirection = target > startProgress ? 'forward' : 'reverse';
    state.root.setAttribute('data-c20-reveal-direction', state.revealDirection);
    var distance = Math.abs(target - startProgress);
    if (distance <= 0.001) {
      state.revealProgress = target;
      setRevealProgress(state, target);
      state.revealDirection = target >= 1 ? 'complete' : 'idle';
      state.root.setAttribute('data-c20-reveal-direction', state.revealDirection);
      return;
    }

    var duration = Math.max(16, distance * COVER_REVEAL_DURATION_MS);
    var startTime = window.performance && window.performance.now ? window.performance.now() : Date.now();

    function tick(now) {
      if (!state || state.destroyed) return;
      var elapsed = Math.max(0, now - startTime);
      var progress = clamp(elapsed / duration, 0, 1);
      state.revealProgress = startProgress + (target - startProgress) * progress;
      setRevealProgress(state, state.revealProgress);

      if (progress < 1) {
        state.autoRevealFrame = window.requestAnimationFrame(tick);
      } else {
        state.autoRevealFrame = 0;
        state.revealProgress = target;
        setRevealProgress(state, target);
        state.revealDirection = target >= 1 ? 'complete' : 'idle';
        state.root.setAttribute('data-c20-reveal-direction', state.revealDirection);
      }
    }

    state.autoRevealFrame = window.requestAnimationFrame(tick);
  }

  function startAutoReveal(state) {
    if (!state || state.destroyed || !scrollDriveEligible(state)) return;
    if (state.hasAutoRevealed) return;
    if (state.autoRevealStarted && state.revealTarget === 1) return;

    state.hasAutoRevealed = true;
    state.autoRevealStarted = true;
    state.revealTarget = 1;
    state.revealDirection = 'forward';
    state.root.setAttribute('data-c20-reveal-direction', 'forward');
    state.root.setAttribute('data-c20-auto-revealed', 'true');
    prepareRevealVideos(state);
    if ((state.revealProgress || 0) <= 0.001) restartRevealVideos(state);
    setRevealProgress(state, state.revealProgress || 0);
    updateMediaPlayback(state);
    waitForRevealVideo(state, function () {
      if (state.autoRevealStarted && state.revealTarget === 1) animateRevealTo(state, 1);
    });
  }

  function reverseAutoReveal(state) {
    if (!state || state.destroyed || !state.hasAutoRevealed) return;

    state.hasAutoRevealed = false;
    state.autoRevealStarted = false;
    state.revealTarget = 0;
    state.revealDirection = 'reverse';
    state.root.setAttribute('data-c20-reveal-direction', 'reverse');
    state.root.setAttribute('data-c20-auto-revealed', 'false');
    cancelVideoReadyWait(state);
    state.root.setAttribute('data-c20-video-waiting', 'false');
    animateRevealTo(state, 0);
  }

  function setProgress(state, progress, rawProgress) {
    var value = clamp(progress, 0, 1);
    var fixed = value.toFixed(4);

    state.root.style.setProperty('--c20-progress', fixed);
    state.root.setAttribute('data-c20-progress', fixed);
    if (rawProgress !== undefined) state.root.setAttribute('data-c20-scroll-progress', clamp(rawProgress, 0, 1).toFixed(4));
  }

  function applyScrollProgress(state, rawProgress) {
    if (!state || state.destroyed) return;
    var progress = visualProgress(rawProgress);
    setProgress(state, progress, rawProgress);
    updateReferenceGyroMotion(state);
    /* OnePlus-style behavior: each threshold crossing starts a short,
       autonomous animation. Scroll position selects the direction without
       scrubbing the reveal frame-by-frame. */
    if (progress > state.threshold && !state.hasAutoRevealed) {
      startAutoReveal(state);
    } else if (progress <= state.threshold && state.hasAutoRevealed) {
      reverseAutoReveal(state);
    }
  }

  function killFallback(state) {
    if (!state.fallbackHandler) return;
    window.removeEventListener('scroll', state.fallbackHandler);
    window.removeEventListener('resize', state.fallbackHandler);
    state.fallbackHandler = null;
    if (state.fallbackFrame) window.cancelAnimationFrame(state.fallbackFrame);
    state.fallbackFrame = 0;
  }

  function updateNativeProgress(state) {
    var rect = state.root.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 1;
    var offset = stickyOffsetPx(state);
    var total = Math.max(1, rect.height - vh + offset);
    applyScrollProgress(state, (offset - rect.top) / total);
  }

  function setupNativeFallback(state) {
    if (!state || state.destroyed || !scrollDriveEligible(state)) {
      if (state) killFallback(state);
      return;
    }
    killFallback(state);
    state.root.classList.remove('is-c20-scroll-ready', 'is-c20-scroll-disabled');
    state.root.classList.add('is-c20-scroll-fallback');

    var ticking = false;
    state.fallbackHandler = function () {
      if (ticking) return;
      ticking = true;
      state.fallbackFrame = window.requestAnimationFrame(function () {
        ticking = false;
        state.fallbackFrame = 0;
        updateNativeProgress(state);
      });
    };

    window.addEventListener('scroll', state.fallbackHandler, { passive: true });
    window.addEventListener('resize', state.fallbackHandler, { passive: true });
    updateNativeProgress(state);
  }

  function killScrollTrigger(state) {
    if (state.scrollTrigger && state.scrollTrigger.kill) state.scrollTrigger.kill();
    state.scrollTrigger = null;
    killFallback(state);
    state.root.classList.remove('is-c20-scroll-ready', 'is-c20-scroll-fallback');
  }

  function scrollDriveEligible(state) {
    return state.enableScrollReveal && state.reveal && desktopMode();
  }

  function mobileLoopEligible(state) {
    return state && state.reveal && !desktopMode();
  }

  function prepareMobileLoopVideos(state) {
    if (!state || state.destroyed || state.mobileVideosPrepared || !mobileLoopEligible(state)) return;
    state.mobileVideosPrepared = true;

    for (var i = 0; i < state.videos.length; i++) {
      var video = state.videos[i];
      if (!videoDisplayed(video)) continue;
      prepareVideoPlaybackAttrs(video, { autoplay: true });
    }

    updateVideoDiagnostics(state);
  }

  function updateMobileLoopPlayback(state) {
    var allow = mobileLoopEligible(state) && state.inViewport !== false && !document.hidden;
    if (allow) prepareMobileLoopVideos(state);
    if (state && state.root) state.root.setAttribute('data-c20-mobile-video-loop', allow ? 'loading' : 'paused');

    for (var i = 0; i < state.videos.length; i++) {
      var video = state.videos[i];
      try {
        if (allow && videoDisplayed(video)) {
          prepareVideoPlaybackAttrs(video, { autoplay: true });
          var play = video.play();
          if (play && play.then) {
            play.then(function () {
              if (state && state.root) state.root.setAttribute('data-c20-mobile-video-loop', 'playing');
            }).catch(function () {
              if (state && state.root) state.root.setAttribute('data-c20-mobile-video-loop', 'blocked');
            });
          } else if (state && state.root) {
            state.root.setAttribute('data-c20-mobile-video-loop', 'playing');
          }
        } else {
          video.pause();
        }
      } catch (e) {}
    }

    updateVideoDiagnostics(state);
  }

  function markScrollDisabled(state) {
    killScrollTrigger(state);
    state.root.classList.add('is-c20-scroll-disabled');
    resetAutoReveal(state);
    state.root.setAttribute('data-c20-reference-progress', '1.0000');
    setBaseEntryProgress(state, 1);
    setProgress(state, 0, 0);
    if (state.reveal) state.reveal.setAttribute('aria-hidden', 'true');
  }

  function syncScrollDriveMode(state) {
    if (!state || state.destroyed) return;
    if (!scrollDriveEligible(state)) markScrollDisabled(state);
  }

  function configureScrollDrive(state) {
    if (!state || state.destroyed) return;
    killScrollTrigger(state);

    if (!scrollDriveEligible(state)) {
      markScrollDisabled(state);
      return;
    }

    primeVideosWhenNear(state);

    if (!window.gsap || !window.ScrollTrigger || !state.stage) {
      setupNativeFallback(state);
      return;
    }

    window.gsap.registerPlugin(window.ScrollTrigger);
    state.root.classList.remove('is-c20-scroll-disabled', 'is-c20-scroll-fallback');

    state.scrollTrigger = window.ScrollTrigger.create({
      trigger: state.root,
      start: function () { return 'top ' + (stickyOffsetPx(state) + 1) + 'px'; },
      end: 'bottom bottom',
      invalidateOnRefresh: true,
      onEnter: function () {
        primeRevealVideos(state);
      },
      onEnterBack: function () {
        primeRevealVideos(state);
      },
      onUpdate: function (self) {
        applyScrollProgress(state, self.progress);
      }
    });

    state.root.classList.add('is-c20-scroll-ready');
    if (window.ScrollTrigger.refresh) window.ScrollTrigger.refresh();
    applyScrollProgress(state, state.scrollTrigger.progress || 0);
  }

  function ensureScrollDrive(state) {
    if (!state || state.destroyed) return;
    if (!scrollDriveEligible(state)) {
      markScrollDisabled(state);
      return;
    }

    primeVideosWhenNear(state);

    if (!window.gsap || !window.ScrollTrigger) {
      setupNativeFallback(state);
      loadVendorDriveWhenNear(state);
      return;
    }

    configureScrollDrive(state);
  }

  function setupAssetRefresh(state) {
    var nodes = state.root.querySelectorAll('img, video');
    for (var i = 0; i < nodes.length; i++) {
      (function (node) {
        var eventName = node.tagName && node.tagName.toLowerCase() === 'video' ? 'loadedmetadata' : 'load';
        var handler = function () {
          updateVideoDiagnostics(state);
          if (!state.destroyed && window.ScrollTrigger && window.ScrollTrigger.refresh) window.ScrollTrigger.refresh();
        };
        node.addEventListener(eventName, handler, { once: true });
        state.cleanups.push(function () {
          node.removeEventListener(eventName, handler);
        });
        if (node.tagName && node.tagName.toLowerCase() === 'video') {
          var readyHandler = function () {
            updateVideoDiagnostics(state);
          };
          node.addEventListener('loadeddata', readyHandler);
          node.addEventListener('canplay', readyHandler);
          state.cleanups.push(function () {
            node.removeEventListener('loadeddata', readyHandler);
            node.removeEventListener('canplay', readyHandler);
          });
        }
      })(nodes[i]);
    }
  }

  function bindLifecycle(state) {
    var visibilityHandler = function () { updateMediaPlayback(state); };
    document.addEventListener('visibilitychange', visibilityHandler);
    state.cleanups.push(function () {
      document.removeEventListener('visibilitychange', visibilityHandler);
    });

    var resizeHandler = function () {
      syncReferenceGyroMotion(state);
      syncScrollDriveMode(state);
      window.clearTimeout(state.resizeTimer);
      state.resizeTimer = window.setTimeout(function () {
        state.stickyOffsetValue = null;
        ensureScrollDrive(state);
        updateMediaPlayback(state);
      }, 150);
    };
    window.addEventListener('resize', resizeHandler, { passive: true });
    state.cleanups.push(function () {
      window.removeEventListener('resize', resizeHandler);
    });
  }

  function clearReferenceGyroMotion(state) {
    if (!state) return;
    if (state.referenceGyroHandler) {
      window.removeEventListener('scroll', state.referenceGyroHandler);
      window.removeEventListener('resize', state.referenceGyroHandler);
      state.referenceGyroHandler = null;
    }
    if (state.referenceGyroFrame) window.cancelAnimationFrame(state.referenceGyroFrame);
    state.referenceGyroFrame = 0;
  }

  function syncReferenceGyroMotion(state) {
    if (!state || state.destroyed) return;
    clearReferenceGyroMotion(state);
    if (!desktopMode()) {
      updateReferenceGyroMotion(state);
      return;
    }

    var ticking = false;
    state.referenceGyroHandler = function () {
      if (ticking) return;
      ticking = true;
      state.referenceGyroFrame = window.requestAnimationFrame(function () {
        ticking = false;
        state.referenceGyroFrame = 0;
        updateReferenceGyroMotion(state);
      });
    };

    window.addEventListener('scroll', state.referenceGyroHandler, { passive: true });
    window.addEventListener('resize', state.referenceGyroHandler, { passive: true });
    updateReferenceGyroMotion(state);
  }

  function setupPlaybackObserver(state) {
    if (!state || state.destroyed || !('IntersectionObserver' in window)) {
      if (state) state.inViewport = true;
      if (state) updateMediaPlayback(state);
      return;
    }

    state.playbackObserver = new IntersectionObserver(function (entries) {
      var visible = false;
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          visible = true;
          break;
        }
      }
      state.inViewport = visible;
      updateMediaPlayback(state);
    });
    state.playbackObserver.observe(state.root);
  }

  function setup(root) {
    if (!root || root.centauriC20State) return root ? root.centauriC20State : null;

    var stage = root.querySelector('[data-c20-stage]');
    var reveal = root.querySelector('[data-c20-reveal]');
    var base = root.querySelector('.centauri-c20-leaf-spring-top__base');
    if (!stage) return null;

    var state = {
      root: root,
      stage: stage,
      base: base,
      reveal: reveal,
      videos: toArray(root.querySelectorAll('video')),
      threshold: switchThreshold(root),
      baseEntryProgress: null,
      revealProgress: 0,
      revealTarget: 0,
      revealDirection: 'idle',
      revealActive: false,
      autoRevealStarted: false,
      hasAutoRevealed: false,
      autoRevealFrame: 0,
      inViewport: true,
      enableScrollReveal: toBool(root.getAttribute('data-enable-scroll-reveal'), toBool(root.getAttribute('data-enable-scroll-tabs'), true)),
      cleanups: [],
      destroyed: false,
      resizeTimer: 0,
      scrollTrigger: null,
      stickyOffsetValue: null,
      stickyOffsetPx: 0,
      fallbackHandler: null,
      fallbackFrame: 0,
      referenceGyroHandler: null,
      referenceGyroFrame: 0,
      vendorObserver: null,
      vendorRequested: false,
      videoPrimeObserver: null,
      playbackObserver: null,
      videoReadyTimer: 0,
      videoReadyCleanup: null,
      videosPrepared: false,
      videosPrimed: false,
      mobileVideosPrepared: false
    };

    root.centauriC20State = state;
    root.setAttribute('data-c20-ready', 'true');
    root.setAttribute('data-c20-reveal-mode', 'autoplay');
    root.setAttribute('data-c20-reveal-direction', 'idle');
    root.setAttribute('data-c20-auto-revealed', 'false');
    bindLifecycle(state);
    syncReferenceGyroMotion(state);
    setupPlaybackObserver(state);
    setupAssetRefresh(state);
    setRevealProgress(state, 0);
    setProgress(state, 0, 0);
    updateVideoDiagnostics(state);
    ensureScrollDrive(state);

    return state;
  }

  function destroyState(state) {
    if (!state || state.destroyed) return;
    cancelAutoReveal(state);
    cancelVideoReadyWait(state);
    state.destroyed = true;
    window.clearTimeout(state.resizeTimer);
    clearReferenceGyroMotion(state);
    killScrollTrigger(state);
    if (state.vendorObserver && state.vendorObserver.disconnect) state.vendorObserver.disconnect();
    state.vendorObserver = null;
    disconnectVideoPrimeObserver(state);
    if (state.playbackObserver && state.playbackObserver.disconnect) state.playbackObserver.disconnect();
    state.playbackObserver = null;

    for (var i = 0; i < state.cleanups.length; i++) {
      try { state.cleanups[i](); } catch (e) {}
    }
    state.cleanups = [];

    for (var v = 0; v < state.videos.length; v++) {
      try { state.videos[v].pause(); } catch (e) {}
    }

    state.root.removeAttribute('data-c20-ready');
    state.root.classList.remove('is-c20-scroll-ready', 'is-c20-scroll-fallback', 'is-c20-scroll-disabled', 'is-c20-active-base', 'is-c20-active-reveal');
    state.root.style.removeProperty('--c20-media-progress');
    state.root.style.removeProperty('--c20-reveal-progress');
    state.root.style.removeProperty('--c20-media-offset');
    state.root.style.removeProperty('--c20-reveal-opacity');
    state.root.style.removeProperty('--c20-base-reveal-scale');
    state.root.style.removeProperty('--c20-base-entry-opacity');
    state.root.style.removeProperty('--c20-base-entry-y');
    state.root.style.removeProperty('--c20-base-entry-scale');
    state.root.removeAttribute('data-c20-media-progress');
    state.root.removeAttribute('data-c20-scroll-progress');
    state.root.removeAttribute('data-c20-reveal-progress');
    state.root.removeAttribute('data-c20-reveal-opacity-progress');
    state.root.removeAttribute('data-c20-media-offset');
    state.root.removeAttribute('data-c20-base-reveal-scale');
    state.root.removeAttribute('data-c20-base-entry-progress');
    state.root.removeAttribute('data-c20-reference-progress');
    state.root.removeAttribute('data-c20-active-index');
    state.root.removeAttribute('data-c20-reveal-mode');
    state.root.removeAttribute('data-c20-reveal-direction');
    state.root.removeAttribute('data-c20-auto-revealed');
    state.root.removeAttribute('data-c20-video-waiting');
    state.root.removeAttribute('data-c20-video-ready');
    state.root.removeAttribute('data-c20-video-width');
    state.root.removeAttribute('data-c20-video-ready-state');
    state.root.removeAttribute('data-c20-mobile-video-loop');
    state.root.centauriC20State = null;
  }

  function init(scope) {
    var roots = findRootNodes(scope);
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  function destroy(scope) {
    var roots = findRootNodes(scope);
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].centauriC20State) destroyState(roots[i].centauriC20State);
    }
  }

  var api = {
    version: VERSION,
    init: init,
    destroy: destroy
  };

  window.CentauriC20ScrollReveal = api;
  window.CentauriC20GyroTabs = api;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event && event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event && event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    init(event && event.target);
  });
})();
